import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';
import './Charts.css';
import { formatIndianCurrency, formatChartAxis } from '../../../utils/currencyFormatter';

const TopItemsChart = ({ data, title = "Top Selling Items" }) => {
  const getColor = (index) => {
    const colors = ['#10b981', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444'];
    return colors[index % colors.length];
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{item.name}</p>
          <p className="tooltip-value">
            Revenue: <strong>{formatIndianCurrency(item.revenue, true, 2)}</strong>
          </p>
          <p className="tooltip-sub">Quantity: {item.quantity}</p>
          <p className="tooltip-sub">Profit Margin: {item.profitMargin}%</p>
          <p className="tooltip-sub">Rating: ⭐ {item.rating}</p>
          {item.trend && (
            <p className={`tooltip-sub ${parseFloat(item.trend) >= 0 ? 'positive' : 'negative'}`}>
              Trend: {parseFloat(item.trend) >= 0 ? '↑' : '↓'} {Math.abs(item.trend)}%
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3 className="chart-title">{title}</h3>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart 
          data={data} 
          layout="vertical"
          margin={{ top: 10, right: 30, left: 100, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            type="number" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            tickFormatter={(value) => formatChartAxis(value)}
          />
          <YAxis 
            type="category" 
            dataKey="name" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            width={90}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="revenue" radius={[0, 4, 4, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getColor(index)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopItemsChart;

